const PREFIX = 'qb:attempts:v1:';

export function progressKey(bankId) {
  return `${PREFIX}${bankId}`;
}

export function loadAttempts(bankId) {
  try {
    const raw = localStorage.getItem(progressKey(bankId));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function saveAttempts(bankId, attempts) {
  try {
    localStorage.setItem(progressKey(bankId), JSON.stringify(attempts));
  } catch {
    /* ignore quota errors */
  }
}

/** Pure merge: append an attempt (stamping ts) and cap to the last `cap` items. */
export function mergeAttempts(list, attempt, cap = 500) {
  const stamped = { ...attempt, ts: attempt.ts == null ? Date.now() : attempt.ts };
  const next = list.concat([stamped]);
  return next.length > cap ? next.slice(next.length - cap) : next;
}

export function addAttempt(bankId, attempt, cap = 500) {
  const next = mergeAttempts(loadAttempts(bankId), attempt, cap);
  saveAttempts(bankId, next);
  return next;
}

/** Aggregate every bank's stored attempts into { [bankId]: attempts[] } for the user_data hub. */
export function collectQuestionBankProgress() {
  const out = {};
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(PREFIX)) {
        const bankId = key.slice(PREFIX.length);
        const val = loadAttempts(bankId);
        if (val.length) out[bankId] = val;
      }
    }
  } catch {
    /* ignore */
  }
  return out;
}
